import React, { useState, useRef } from 'react';
import { Input, Tag, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const EmbeddedChipsInput = ({ onChange, value, title, maxLength, placeholder }) => {
    const [chips, setChips] = useState(value || []);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);
    const chipLimit = typeof maxLength === 'number' ? maxLength : Infinity;
    const { Title } = Typography
    const addChip = () => {
        const trimmed = inputValue.trim().replace(/,+$/, '');
        if (trimmed && !chips.includes(trimmed) && chips.length < chipLimit) {
            const newChips = [...chips, trimmed];
            setChips(newChips);
            onChange?.(newChips);
        }
        setInputValue('');
    };

    const handleKeyDown = (e) => {
        if ([13, 9, 188].includes(e.keyCode)) {
            e.preventDefault();
            addChip();
        } else if (e.keyCode === 8 && inputValue.length === 0 && chips.length) {
            const newChips = chips.slice(0, -1);
            setChips(newChips);
            onChange?.(newChips);
        }
    };

    const removeChip = (removed) => {
        const newChips = chips.filter(chip => chip !== removed);
        setChips(newChips);
        onChange?.(newChips);
    };

    return (
        <div style={{ maxWidth: "100%" }}>
            {title && (
                <Title style={{ fontSize: 12, marginBottom: "15px" }}>
                    {title}
                    {typeof maxLength === 'number' && (
                        <span style={{ float: 'right', color: chips.length >= chipLimit ? 'red' : '#999' }}>
                            ({chips.length}/{chipLimit})
                        </span>
                    )}
                </Title>
            )}

            <div
                style={{
                    minHeight: 40,
                    border: '1px solid #d9d9d9',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    padding: '4px 8px',
                    borderRadius: 4,
                    gap: 6,
                    width: "100%",
                    marginTop: "10px"
                }}
                onClick={() => inputRef.current?.focus()}
            >
                {chips.map((chip, index) => (
                    <Tag
                        key={index}
                        closable
                        onClose={() => removeChip(chip)}
                        style={{ marginBottom: 4 }}
                        closeIcon={<CloseOutlined />}
                    >
                        {chip}
                    </Tag>
                ))}
                <Input
                    ref={inputRef}
                    type="text"
                    size="small"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    style={{
                        border: 'none',
                        outline: 'none',
                        boxShadow: 'none',
                        flexGrow: 1,
                        minWidth: "100%"
                    }}
                    placeholder={placeholder || "Type and press Enter"}
                    disabled={chips.length >= chipLimit}
                />
            </div>
        </div>
    );
};

export default EmbeddedChipsInput;
